import { CARE_PLAN_ITEM_KIND_SYSTEM, CARE_PLAN_ITEM_KINDS } from '@liza/fhir-utils';
import type { CodeSystem, CodeSystemConcept } from '@medplum/fhirtypes';

/**
 * The kind of care-plan item a Task is — what the board's add/edit/remove menus and the AI tools
 * branch on. A rollup of the finer task category: `measurement` and `medication` map one-to-one,
 * every lifestyle category collapses to `lifestyle`, anything else is a generic `task`. Written as a
 * coding on `Task.code.coding[]`; the code list is `CARE_PLAN_ITEM_KINDS` in `@liza/fhir-utils`.
 *
 * Today `getCarePlanItemKind` derives this by running predicates in a fixed order; the coding makes
 * the answer a stored, searchable fact (`code=<system>|medication`).
 */
const DISPLAY: Record<(typeof CARE_PLAN_ITEM_KINDS)[number], string> = {
  measurement: 'Measurement',
  medication: 'Medication',
  lifestyle: 'Lifestyle change',
  task: 'Task',
};

const CONCEPTS: CodeSystemConcept[] = CARE_PLAN_ITEM_KINDS.map((code) => ({ code, display: DISPLAY[code] }));

export const carePlanItemKindCodeSystem: CodeSystem = {
  resourceType: 'CodeSystem',
  url: CARE_PLAN_ITEM_KIND_SYSTEM,
  name: 'care-plan-item-kind',
  title: 'Liza Care Plan Item Kind',
  identifier: [{ system: 'urn:ietf:rfc:3986', value: CARE_PLAN_ITEM_KIND_SYSTEM }],
  status: 'active',
  content: 'complete',
  concept: CONCEPTS,
};
